import React, { Component } from 'react';
import { connect } from "react-redux";
import {NONE, WAITING, SYNCED, DISCONNECTED} from 'constants/connection-status-types.js';

class ConnectionStatus extends Component {
    onClick() {
        if (this.props.connectionStatus === DISCONNECTED) {
            this.props.sequencerEngine.clockSync.retry();
        }
    }

    render() {
        if (this.props.connectionStatus === NONE) {
            return (<div></div>);
        }

        let text = '';
        if (this.props.connectionStatus === WAITING) {
            text = 'Waiting for peer to connect';
        } else if (this.props.connectionStatus === DISCONNECTED) {
            text = 'Disconnected (click to retry)';
        } else {
            text = 'Synced with ' + this.props.connectedUserName;
        }

        let otherClass = this.props.connectionStatus === WAITING ?
            ' flashit' : '';

        
        return (
            <div
              onClick={() => this.onClick()}
              className={"connection-status " + this.props.connectionStatus + otherClass}>
              {text} <div className="clock-type">{this.props.clockType}</div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        connectedUserName: state.clock.connectedUserName,
        connectionStatus: state.clock.connectionStatus,
        clockType: state.sequencer.clockType,
   }
};

export default connect(mapStateToProps, null)(ConnectionStatus);
 
